import React from 'react';
import { Icon, type IconName } from '../../../assets/icons/icons';
import { ANSWER_SLA_DAYS } from '../../../entities/supportRequests/model/constants';
import { RequestsSummary } from '../../../entities/supportRequests/model/types';
import { cx } from '../../../utils/cx';
import styles from './SummaryCards.module.scss';

export interface SummaryCardsProps {
    summary: RequestsSummary;
}

type Tone = 'neutral' | 'fresh' | 'wait' | 'done';

interface CardData {
    key: string;
    value: number;
    label: string;
    icon: IconName;
    tone: Tone;
}

export function SummaryCards({ summary }: SummaryCardsProps) {
    const cards: CardData[] = [
        { key: 'total', value: summary.total, label: 'Всего запросов', icon: 'list', tone: 'neutral' },
        { key: 'fresh', value: summary.fresh, label: 'Новые, без ответа', icon: 'mail', tone: 'fresh' },
        {
            key: 'overdue',
            value: summary.overdue,
            label: 'Ждут ответа дольше ' + ANSWER_SLA_DAYS + ' дней',
            icon: 'clock',
            tone: 'wait',
        },
        { key: 'done', value: summary.doneLastMonth, label: 'Завершено за месяц', icon: 'checkCircle', tone: 'done' },
    ];

    return (
        <section className={styles.grid}>
            {cards.map((card) => (
                <article key={card.key} className={styles.card}>
                    <span className={cx(styles.icon, styles[card.tone])}>
                        <Icon name={card.icon} size={16} />
                    </span>
                    <div>
                        <div className={styles.value}>{card.value}</div>
                        <div className={styles.label}>{card.label}</div>
                    </div>
                </article>
            ))}
        </section>
    );
}
